import React, { useEffect, useState } from "react";

import { Box, Grid, styled } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { useTranslation } from "react-i18next";
import deleteImg from "../../../images/delete.svg";
import { handleRemoveItem } from "../../CartListItem";

const TextDomainStyles = {
  fontFamily: "Roboto",
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "14.06px",
};

const GridContainer = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "3fr 2fr 70px",
}));

const TextHeader = styled("p")(() => ({
  fontFamily: "Roboto",
  fontSize: "13px",
  fontWeight: 700,
  lineHeight: "28px",
  color: "#2287B8",
  marginBottom: "8px",
}));

const TextNameProduct = styled("p")(() => ({
  marginBottom: 0,
  fontFamily: "Roboto",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "18.75px",
  color: "#191D23",
}));

const DescriptionProduct = styled("div")(() => ({
  fontFamily: "Roboto",
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "14.06px",
}));

const PriceProduct = ({ cost = "", cross_price = true, second_price = "" }) => {
  const currency = useSelector((state) => state.global.currency);

  const Container = styled("p")(() => ({
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "4px",
    textAlign: "right",
    marginBottom: 0,
    ">span": {
      fontFamily: "Patua One",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: 1,
      color: "#191D23",
    },
  }));

  return (
    <Container>
      {cross_price && cost > second_price && (
        <span style={{ color: "#64748B", textDecoration: "line-through" }}>
          ${cost} {currency}
        </span>
      )}
      <span>
        ${second_price} {currency}
      </span>
    </Container>
  );
};

/**
 * @see src/components/CartListItem.js
 */
const ButtonDelete = ({ data, globalState }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <img
        src={deleteImg}
        alt="Icono eliminar producto"
        style={{ cursor: "pointer" }}
        onClick={() => handleRemoveItem(globalState, data, dispatch, t)}
      />
    </div>
  );
};

const RowProductDomain = ({ item, domainProducts = [] }) => {
  const { t } = useTranslation();
  const domainFree = parseFloat(item.price.second_price) === 0;
  const transferDomain = item.product.name === "Transferencia de Dominio";
  const domain = item.product.domain_section[0].dominio_principal;
  const hostingWithDomain = domainProducts.includes(domain);

  return (
    <>
      {/* dominio del producto */}
      <Grid item xs={3}>
        <span className="dominio-drawer">
          <MdKeyboardDoubleArrowRight color={domain ? "#46AA71" : "#2287B8"} style={{ marginRight: 3 }} />
          {/* sin dominio relacionado */}
          {!domain && <span style={TextDomainStyles}>{t("resumen.content.nodomain")}</span>}
          {/* con dominio relacionado  */}
          {domain && <span style={TextDomainStyles}>{domain}</span>}
        </span>
      </Grid>

      <Grid
        item
        xs={2}
        sx={{
          textAlign: "right",
          fontFamily: "Roboto",
          fontSize: "10px",
          fontWeight: 700,
          lineHeight: 1,
          color: "#F79E1B",
        }}
      >
        {/* gratis con hosting */}
        {!transferDomain && domainFree && hostingWithDomain ? t("resumen.content.gratish") : ""}
        {/* gratis por transferencia */}
        {transferDomain && domainFree && hostingWithDomain ? t("resumen.content.gratis") : ""}
      </Grid>
    </>
  );
};

const RowDomainPrivateWHOIS = ({ price, formatAmount }) => {
  const { t } = useTranslation();
  return (
    <>
      {price.privacy_cost && (
        <>
          <Grid item xs={3} sx={TextDomainStyles}>
            <MdKeyboardDoubleArrowRight color="#46AA71" /> {t("resumen.content.privacidad")}
          </Grid>
          <Grid
            item
            xs={2}
            sx={{
              fontFamily: "Patua One",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: 1,
              color: "#191D23",
              textAlign: "right",
            }}
          >
            {formatAmount(price.privacy_cost)}
          </Grid>
        </>
      )}
    </>
  );
};

const DrawerBody = ({ itemsAddCart = [], formatAmount, globalState }) => {
  const [domainProducts, setDomainProducts] = useState([]);

  useEffect(() => {
    const productsWithDomain = itemsAddCart.filter((item) => {
      const domain = item.product.domain_section[0].dominio_principal;

      return item.product.id && domain;
    });
    const domainProducts = productsWithDomain.map((item) => item.product.domain_section[0].dominio_principal);

    setDomainProducts(domainProducts);
  }, [itemsAddCart]);

  return (
    <Box sx={{ flex: 1, px: 3, overflow: "auto", pb: 0 }}>
      <GridContainer
        style={{
          position: "sticky",
          top: "0",
          backgroundColor: "#ffffff",
          paddingTop: "1rem",
          zIndex: 1,
        }}
      >
        <TextHeader>Producto</TextHeader>
        <TextHeader sx={{ textAlign: "center" }}>Total</TextHeader>
        <TextHeader sx={{ textAlign: "center" }}>Acciones</TextHeader>
      </GridContainer>

      {itemsAddCart.map((item, index) => (
        <GridContainer
          key={item.id}
          sx={{
            minHeight: "50px",
            pt: "15px",
            borderBottom: itemsAddCart.length !== index + 1 ? "1px solid #46AA71" : "none",
            pb: itemsAddCart.length === index + 1 ? 0 : "15px",
          }}
        >
          <div style={{ gridColumnStart: 1, gridColumnEnd: 3 }}>
            <Grid container spacing={0} columns={5}>
              <Grid item xs={3}>
                <TextNameProduct>
                  {item.product.smallname} - {item.periodo}
                </TextNameProduct>
              </Grid>
              <Grid item xs={2}>
                <PriceProduct {...item.price} />
              </Grid>

              <RowProductDomain item={item} domainProducts={domainProducts} />

              {item.product.privacy_protection && <RowDomainPrivateWHOIS price={item.price} formatAmount={formatAmount} />}

              {/* descripción del producto */}
              {item.product.description && (
                <>
                  <Grid item xs={3}>
                    <DescriptionProduct
                      className="custom-list"
                      dangerouslySetInnerHTML={{
                        __html: item.product.description,
                      }}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </>
              )}

              {/* características de VPS [panel_admin, so] */}
              {(item.product.domain_section[0].panel_admin || item.product.domain_section[0].so) && (
                <>
                  <Grid item xs={3}>
                    <DescriptionProduct className="custom-list">
                      <ul>
                        {item.product.domain_section[0].panel_admin && <li>{item.product.domain_section[0].panel_admin}</li>}
                        {item.product.domain_section[0].so && <li>{item.product.domain_section[0].so}</li>}
                      </ul>
                    </DescriptionProduct>
                  </Grid>
                  <Grid item xs={2}></Grid>
                </>
              )}
            </Grid>
          </div>

          <ButtonDelete data={item} globalState={globalState} />
        </GridContainer>
      ))}
    </Box>
  );
};

export default DrawerBody;
